import { Component } from '@angular/core';

@Component({
  selector: 'app-historical-component',
  templateUrl: './historical-component.component.html',
  styleUrls: ['./historical-component.component.scss']
})
export class HistoricalComponentComponent {
	active=false;
	FuncionComponent(){
		if(this.active==false){
			this.active=true;
		}else{
			this.active=false
		}
	}
}
